import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-monitoring-cloud',
    templateUrl: './monitoring-cloud.component.html',
    styleUrls: ['./monitoring-cloud.component.scss'],
    standalone: false
})
export class MonitoringCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
